module.exports = __webpack_public_path__ + "img/2.15a037a6.png";